import React from 'react';
import { useGetCompaniesQuery } from '../../Companies/Service/companiesApi';
import type { Company } from '../../Companies/Types/companyTypes';
import {
  mapCompanyToExpenseInvoiceLookup,
  type ExpenseInvoiceCompanyLookup,
} from './expenseInvoiceCompaniesLookupMapper';

type CompaniesQueryOptions = Parameters<typeof useGetCompaniesQuery>[1];
type CompaniesQueryResult = ReturnType<typeof useGetCompaniesQuery>;

type ExpenseInvoiceCompaniesLookupQueryResult = Pick<
  CompaniesQueryResult,
  'isLoading' | 'isFetching' | 'isError' | 'error' | 'refetch'
> & {
  data: ExpenseInvoiceCompanyLookup[];
};

export const useGetExpenseInvoiceCompaniesLookupQuery = (
  options?: CompaniesQueryOptions
): ExpenseInvoiceCompaniesLookupQueryResult => {
  const queryResult = useGetCompaniesQuery(undefined, options);

  const data = React.useMemo(
    () =>
      (queryResult.data ?? [])
        .map((company: Company) => mapCompanyToExpenseInvoiceLookup(company))
        .filter(
          (
            company: ExpenseInvoiceCompanyLookup | undefined
          ): company is ExpenseInvoiceCompanyLookup => Boolean(company)
        ),
    [queryResult.data]
  );

  return {
    data,
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
};
